export default "__VITE_ASSET__ClAB5Bgs__"